export const GET_DOCUMENT_LIST = "GET_DOCUMENT_LIST";
export const GET_DOCUMENT_LIST_SUCCESS = "GET_DOCUMENT_LIST_SUCCESS";
export const GET_DOCUMENT_LIST_FAILED = "GET_DOCUMENT_LIST_FAILED";
export const GET_DOCUMENT_LIST_RESET = "GET_DOCUMENT_LIST_RESET"
